import PageHeader, { BackpackThemedLoggedOutPageHeader, DashboardThemedPageHeader, GroupThemedPageHeader, GroupThemedLoggedOutPageHeader } from './PageHeader';

export {
  DashboardThemedPageHeader,
  GroupThemedPageHeader,
  GroupThemedLoggedOutPageHeader,
  BackpackThemedLoggedOutPageHeader,
};

export default PageHeader;
